"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var styles_1 = require("@material-ui/core/styles");
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var actions_1 = require("../../redux/reducers/account-activation/actions");
var ActivationContent_1 = __importDefault(require("./components/ActivationContent"));
var styles_2 = __importDefault(require("./styles"));
var AccountActivationScreen = function (_a) {
    var identifier = _a.identifier;
    var theme = (0, styles_1.useTheme)();
    var classes = (0, styles_2.default)(theme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = (0, react_redux_1.useSelector)(function (state) { return state.accountActivation; }), success = _b.success, failure = _b.failure, loading = _b.loading;
    react_1.default.useEffect(function () {
        if (!!identifier) {
            dispatch((0, actions_1.activateAccount)(identifier));
        }
        return function () {
            dispatch((0, actions_1.reset)());
        };
    }, [identifier]);
    var parseFailure = function () {
        if (success) {
            return 'success';
        }
        if (failure && failure.payload) {
            var message = failure.payload.errorKey;
            if (message === 'activated.already') {
                return 'active';
            }
            else if (message === 'error.activation.expired') {
                return 'expired';
            }
            else if (message === 'error.user.notfound') {
                return 'notFound';
            }
            else if (failure.payload.status === 500) {
                return failure.payload.title;
            }
        }
        return 'error';
    };
    return (react_1.default.createElement("div", { className: classes.screen },
        react_1.default.createElement("div", { className: classes.container },
            react_1.default.createElement(Grid_1.default, { container: true, justify: "center", item: true, xs: 12 },
                react_1.default.createElement(ActivationContent_1.default, { type: parseFailure(), loading: loading })))));
};
exports.default = AccountActivationScreen;
//# sourceMappingURL=index.js.map